import { ChevronSmallDownIcon } from '../../icons/index.js';

const MuiSelectOverrides = {
  MuiSelect: {
    defaultProps: {
      variant: 'standard',
      IconComponent: ChevronSmallDownIcon
    },
    styleOverrides: {
      standard: _ref => {
        let {
          theme
        } = _ref;
        return {
          '&.MuiSelect-select': {
            padding: theme.spacing(1.25, 4.5, 1.25, 1.5)
          }
        };
      },
      iconStandard: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          marginRight: theme.spacing(1),
          color: theme.palette.blue80
        };
      }
    }
  },
  MuiNativeSelect: {
    styleOverrides: {
      select: {
        lineHeight: 1.5
      },
      standard: _ref3 => {
        let {
          theme
        } = _ref3;
        return {
          '&.MuiNativeSelect-select': {
            padding: theme.spacing(1, 4.5, 1, 1.5)
          }
        };
      },
      iconStandard: _ref4 => {
        let {
          theme
        } = _ref4;
        return {
          marginRight: theme.spacing(1),
          color: theme.palette.blue80
        };
      }
    }
  }
};

export { MuiSelectOverrides };
